// Portuguese postal code → district (distrito) approximate mapping based on CP4.
// Not exhaustive, but covers all mainland + islands with sensible defaults.
// Ranges are inclusive [from, to].
const CP4_RANGES = [
  [1000, 1999, "Lisboa"],
  [2000, 2260, "Santarém"],
  [2270, 2354, "Santarém"],
  [2360, 2439, "Santarém"],
  [2400, 2560, "Leiria"],
  [2500, 2565, "Leiria"],
  [2565, 2799, "Lisboa"],
  [2800, 2999, "Setúbal"],
  [3000, 3499, "Coimbra"],
  [3500, 3699, "Viseu"],
  [3700, 3899, "Aveiro"],
  [3900, 3999, "Aveiro"],
  [4000, 4585, "Porto"],
  [4586, 4699, "Porto"],
  [4700, 4799, "Braga"],
  [4800, 4990, "Braga"],
  [5000, 5299, "Vila Real"],
  [5300, 5499, "Bragança"],
  [5500, 5999, "Bragança"],
  [6000, 6299, "Castelo Branco"],
  [6300, 6499, "Guarda"],
  [6500, 6699, "Guarda"],
  [6700, 6999, "Castelo Branco"],
  [7000, 7499, "Évora"],
  [7100, 7499, "Portalegre"],
  [7500, 7599, "Setúbal"],
  [7600, 7999, "Beja"],
  [8000, 8999, "Faro"],
  [9000, 9400, "Madeira"],
  [9500, 9980, "Açores"],
];

/**
 * Look up the Portuguese district from a postal code prefix (CP4).
 * Accepts inputs like "2725", "2725-025", "2725025", "2725 025".
 * Returns null when the code is invalid or out of range.
 */
export function districtFromPostalCode(input) {
  if (!input) return null;
  const digits = String(input).replace(/\D/g, "");
  if (digits.length < 4) return null;
  const cp4 = parseInt(digits.slice(0, 4), 10);
  if (Number.isNaN(cp4)) return null;
  // Last match wins so later, more specific ranges (e.g., 7100-7499 Portalegre)
  // override earlier broader ones (7000-7499 Évora) for the overlap.
  let match = null;
  for (const [from, to, name] of CP4_RANGES) {
    if (cp4 >= from && cp4 <= to) match = name;
  }
  return match;
}

/**
 * Format a raw postal-code string into "NNNN-NNN" as the user types.
 */
export function formatPostalCode(input) {
  if (!input) return "";
  const digits = String(input).replace(/\D/g, "").slice(0, 7);
  if (digits.length <= 4) return digits;
  return `${digits.slice(0, 4)}-${digits.slice(4)}`;
}
